import React from 'react';
import { Grid, Paper, Typography, Box, Skeleton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faExclamationCircle, faClock, faChartLine } from '@fortawesome/free-solid-svg-icons';

export default function StatsHeader({ stats, loading }) {
    
    // Configuración de las tarjetas
    const cards = [
        { 
            label: 'Citas Hoy', 
            value: stats?.today_count ?? 0, 
            icon: faCalendarCheck, 
            color: '#3788d8', // Azul
            sub: 'Volumen diario' 
        },
        { 
            label: 'Pendientes', 
            value: stats?.pending_count ?? 0, 
            icon: faExclamationCircle, 
            color: '#f39c12', // Naranja (Alerta)
            sub: 'Requieren acción' 
        },
        { 
            label: 'Completadas', 
            value: stats?.completed_today ?? 0, 
            icon: faChartLine, 
            color: '#27ae60', // Verde
            sub: 'Productividad hoy' 
        },
        { 
            label: 'Próxima Cita', 
            value: stats?.next_booking?.time ?? '--:--', 
            text: stats?.next_booking?.client ?? 'Sin próximas citas',
            icon: faClock, 
            color: '#8e44ad', // Morado
            sub: stats?.next_booking?.human ?? '' 
        },
    ];

    return (
        <Grid container spacing={3} mb={3}>
            {cards.map((card, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', height: '100%', borderRadius: 3, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                        <Box sx={{ 
                            width: 50, height: 50, borderRadius: '50%', 
                            bgcolor: `${card.color}20`, // Color con transparencia
                            color: card.color,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2 
                        }}>
                            <FontAwesomeIcon icon={card.icon} size="lg" />
                        </Box>
                        <Box>
                            <Typography variant="body2" color="text.secondary" fontWeight="bold">
                                {card.label}
                            </Typography>
                            {loading ? (
                                <Skeleton width={60} height={30} />
                            ) : (
                                <>
                                    <Typography variant="h5" fontWeight="900">
                                        {card.value}
                                    </Typography>
                                    <Typography variant="caption" color="text.disabled" sx={{ display:'block', lineHeight: 1 }}>
                                        {card.text || card.sub}
                                    </Typography>
                                </>
                            )}
                        </Box>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
}